import { ALLOWED_LANGUAGES, DEFAULT_LANGUAGE } from './constants';

export const detectLanguage = (defaultLanguage?: string | null) => {
  if (defaultLanguage && ALLOWED_LANGUAGES.includes(defaultLanguage)) {
    return defaultLanguage;
  }

  if (APP_NAME !== 'admin') {
    const browserLang = window.navigator.language.slice(0, 2);

    return ALLOWED_LANGUAGES.includes(browserLang)
      ? browserLang
      : DEFAULT_LANGUAGE;
  }

  return DEFAULT_LANGUAGE;
};

const loadLanguage = (locale = detectLanguage(), filename: string) =>
  fetch(
    `${BASE_URL}i18n/${locale}/${filename}.json${
      BUILD_SHA ? `?version=${BUILD_SHA}` : ''
    }`,
  ).then((response) => response.json());

export default loadLanguage;
